// GENERATED by tools/single-file.py — the ladders below are loop regions inside one bounced
// file, not hand-written numbers. Re-render with:
//   npx vite-node tools/dump-banks.mts /tmp/rerender/banks.json
//   python3 tools/single-file.py /tmp/rerender/banks.json porsche-911-gt3-cup-4v /tmp/rerender/porsche-911-gt3-cup   (sources: see the docstring)
//   python3 tools/single-file.py encode porsche-911-gt3-cup-4v /tmp/rerender/porsche-911-gt3-cup && python3 tools/apply-ladders.py ...
//
// The GT3 Cup is the one car this is NOT the product for: the public 911 keeps its two banks and its
// own faders, and this bounce sits in the admin shelf beside it so the two can be driven back to
// back. Its ON/OFF renders carry the car's own onMixFloor of 0.2, which is why the profile below is
// given a floor of 0 - the floor is in the audio now, not in the mix.
import type { EngineLoopSample } from '../CarProfile';
import { asSingleFile } from '../single-file';
import { flatSixCup } from '../flat-six-cup';

const loop = (id: string, file: string, recordedRpm: number, loopStart: number, loopEnd: number): EngineLoopSample =>
  ({ id, file, recordedRpm, loopStart, loopEnd });

export const flatSixCupSingle = asSingleFile(flatSixCup, {
  id: 'porsche-911-gt3-cup',
  slug: '510-hp-flat-six',
  name: '510 HP FLAT-SIX',
  adminOnly: false,
  baseGain: 1.000,
  on: [
  loop('on_1920', 'single', 1920, 0.000000, 1.993104),
  loop('on_2500', 'single', 2500, 1.993104, 3.989458),
  loop('on_3000', 'single', 3000, 3.989458, 5.988562),
  loop('on_3400', 'single', 3400, 5.988562, 7.984375),
  loop('on_3960', 'single', 3960, 7.984375, 9.984208),
  loop('on_4800', 'single', 4800, 9.984208, 11.981417),
  loop('on_5400', 'single', 5400, 11.981417, 13.977708),
  loop('on_5800', 'single', 5800, 13.977708, 15.977187),
  loop('on_6360', 'single', 6360, 15.977187, 17.976792),
  loop('on_7200', 'single', 7200, 17.976792, 19.976375),
  loop('on_7730', 'single', 7730, 19.976375, 21.974062),
  loop('on_8200', 'single', 8200, 21.974062, 23.972292),
  loop('on_9000', 'single', 9000, 23.972292, 25.970292),
  ],
  mid: [],
  off: [
  loop('off_1920', 'single', 1920, 25.970292, 27.963396),
  loop('off_2500', 'single', 2500, 27.963396, 29.959542),
  loop('off_3000', 'single', 3000, 29.959542, 31.955854),
  loop('off_3400', 'single', 3400, 31.955854, 33.955458),
  loop('off_3960', 'single', 3960, 33.955458, 35.955312),
  loop('off_4800', 'single', 4800, 35.955312, 37.954583),
  loop('off_5400', 'single', 5400, 37.954583, 39.952479),
  loop('off_5800', 'single', 5800, 39.952479, 41.949125),
  loop('off_6360', 'single', 6360, 41.949125, 43.949125),
  loop('off_7200', 'single', 7200, 43.949125, 45.946354),
  loop('off_7730', 'single', 7730, 45.946354, 47.945146),
  loop('off_8200', 'single', 8200, 47.945146, 49.942708),
  loop('off_9000', 'single', 9000, 49.942708, 51.941167),
  ],
});
